import { Utils } from "@/lib/utils";
import { motion, useScroll } from "framer-motion";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

interface HeaderProps {
      title?: string | null;
      description?: string | null;
      version?: string | null;
      logo?: string | null;
      backgroundCover?: string | null;
      fixed?: boolean;
      widgetMode?: boolean;
      textColor: string;
}

const Header = ({ title, description, version, logo, backgroundCover, fixed = false, widgetMode = false, textColor = '#ffffff' }: HeaderProps) => {
      const t = useTranslations('newsfeed');
      const { scrollY } = useScroll();
      const [isScrolled, setIsScrolled] = useState(false);

      useEffect(() => {
            const updateScroll = () => {
                  setIsScrolled(window.scrollY > 100);
            };
            window.addEventListener("scroll", updateScroll);
            return () => window.removeEventListener("scroll", updateScroll);
      }, [scrollY]);

      const backgroundImage = `url('${Utils.image.getImageUrl(backgroundCover ? backgroundCover : '/assets/congruent_pentagon.webp')}')`;
      const logoUrl = Utils.image.getImageUrl(logo ?? '/logo/logo_short.png');

      const HeaderDefault = () => {
            return (
                  <header className={`w-full overflow-hidden py-12 no-repeat bg-cover relative bg-black/40 shadow-xl`}
                        style={{ backgroundImage }}>
                        <div className={`container mx-auto flex items-center justify-center`}>
                              <div className="flex flex-col items-center text-center">
                                    {logo && <motion.div
                                          className={`h-14 w-14 rounded-xl bg-card p-2 shadow-lg transition-all mb-2`}
                                          layout
                                    >
                                          <img src={logoUrl} alt={title ?? ""} className="h-full w-full" />
                                    </motion.div>}
                                    <h1 className="mb-2 text-4xl font-bold md:text-5xl  drop-shadow-xl" style={{ color: textColor }}>
                                          {title}
                                    </h1>
                                    <p className="mb-6 max-w-xl text-lg  drop-shadow-xl" style={{ color: textColor }}  >
                                          {description}
                                    </p>
                                    {/* {version && <Badge variant="secondary" className="bg-black/40 text-white hover:bg-black/50 backdrop-blur-sm">
                                          {t('latest_version')} {version}
                                    </Badge>} */}
                              </div>
                        </div>
                  </header>
            )
      }

      const HeaderFixed = () => {
            return (
                  <motion.header
                        className={`flex items-center w-full overflow-hidden no-repeat bg-cover sticky top-0 left-0 right-0 z-10 px-2 shadow-xl`}
                        animate={{
                              height: isScrolled ? "4rem" : "6rem",
                              paddingTop: isScrolled ? "0.5rem" : "1rem",
                              paddingBottom: isScrolled ? "0.5rem" : "1rem",
                        }}
                        transition={{ duration: 0.3 }}
                        style={{ backgroundImage }}>

                        <div className="container mx-auto max-w-4xl">
                              <div className="flex items-center gap-2">
                                    <motion.div
                                          className="flex items-center"
                                          animate={{
                                                scale: isScrolled ? 0.8 : 1
                                          }}
                                          transition={{ duration: 0.3 }}>
                                          <img src={logoUrl} alt={title ?? ""} className="h-8 w-8" />
                                    </motion.div>

                                    <motion.div
                                          className="flex flex-col items-start grow"
                                          animate={{
                                                scale: isScrolled ? 0.95 : 1
                                          }}
                                          transition={{ duration: 0.3 }}>
                                          <h1 className="text-xl font-bold text-foreground drop-shadow-xl" style={{ color: textColor }}>
                                                {title}
                                          </h1>
                                          <p className="text-sm drop-shadow-md text-foreground" style={{ color: textColor }}>
                                                {description}
                                          </p>
                                    </motion.div>

                                    {/* <motion.div
                                          className="flex items-center"
                                          animate={{
                                                scale: isScrolled ? 0.9 : 1
                                          }}
                                          transition={{ duration: 0.3 }}>
                                          {version && <Badge variant="secondary" className="bg-black/40 text-white hover:bg-black/50 backdrop-blur-sm">
                                                {t('latest_version')} {version}
                                          </Badge>}
                                    </motion.div> */}
                              </div>
                        </div>
                  </motion.header>
            )
      }



      return (
            fixed || widgetMode ? <HeaderFixed /> : <HeaderDefault />
      )
}


export default Header;  